import HttpTransport from '@/bundles/Http/transport/HttpTransport';
import ErrorMapper from '@/bundles/Http/mappers/ErrorMapper';

export class AppService {
  protected readonly transport: HttpTransport;
  protected readonly errorMapper: ErrorMapper;

  constructor (transport: HttpTransport, errorMapper: ErrorMapper) {
    this.transport = transport;
    this.errorMapper = errorMapper;
  }
}
